(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["random-slider"] && !Shopify.designMode) return;
  try {
    
$('[class^=rs-slideshow]').css('opacity', 0);
$(document).ready(function(){
  $('.rs-slideshow-wrapper').bxSlider({
      slideWidth: 1280,
      minSlides: 1,
      maxSlides: 1,
      controls: false,
      auto: true,
      pause: 10000,
  });
  $('[class^=rs-slideshow]').css('opacity', 1);
  
  // Random number here
  var randomNumber = Math.floor(Math.random() * 3) + 1; 
  if (randomNumber == 1) {
    $( '#random-slider-2' ).remove();
    $( '#random-slider-3' ).remove();
  } else if (randomNumber == 2) {
    $( '#random-slider-1').remove();
    $( '#random-slider-3').remove();
  } else if (randomNumber == 3) {
    $( '#random-slider-1' ).remove();
    $( '#random-slider-2' ).remove();
  }
});

  } catch(e) { console.error(e); }
})();
})();
